import type { LineageFlowEdgeData } from '@repo/api-codegen';
import type { Edge } from '@xyflow/react';

export interface LineageFlowEdge extends Edge<LineageFlowEdgeData> {}

export function isEntityEdge(edge: LineageFlowEdge) {
	if (!edge || typeof edge !== 'object') {
		return false;
	}

	const candidate = edge;
	return (
		candidate.type === 'ENTITY' &&
		candidate.sourceHandle &&
		candidate.sourceHandle.startsWith('MAIN_SOURCE') &&
		candidate.targetHandle &&
		candidate.targetHandle.startsWith('MAIN_TARGET')
	);
}
